import { useEffect, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
// Above-fold — always eager
import Nav from "../components/Nav";
import Hero from "../components/Hero";
// Below-fold — lazy loaded, parsed only when needed
const TrustProcess = lazy(() => import("../components/TrustProcess"));
const WhyBringy = lazy(() => import("../components/WhyBringy"));
const HowItWorks = lazy(() => import("../components/HowItWorks"));
const TrustTicker = lazy(() => import("../components/TrustTicker"));
const RoutesGrid = lazy(() => import("../components/RoutesGrid"));
const ServicesSplit = lazy(() => import("../components/ServicesSplit"));
const FAQ = lazy(() => import("../components/FAQ"));
const Contact = lazy(() => import("../components/Contact"));
const Footer = lazy(() => import("../components/Footer"));

export default function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    const tryScroll = (attempts = 0) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (attempts < 12) {
        setTimeout(() => tryScroll(attempts + 1), 60);
      }
    };
    tryScroll();
  }, [hash]);

  return (
    <main className="relative bg-[#F1F5F9] text-[#0D1B2A] overflow-hidden" data-testid="landing-page">
      <Nav />
      <Hero />
      <Suspense fallback={null}>
        <TrustProcess />
        <WhyBringy />
        <HowItWorks />
        <TrustTicker />
        <RoutesGrid />
        <ServicesSplit />
        <FAQ />
        <Contact />
        <Footer />
      </Suspense>
    </main>
  );
}
